// extracted by mini-css-extract-plugin
export default {"relatedCards":"RelatedResources-module__relatedCards__ugvUcjg"};